import { useCallback, useMemo } from "react";

import { useEditor, useNode } from "@craftjs/core";

import { useUtilities } from "@/modules/cms/views/post/components/builder/context";

import { Action } from "../../../../base";

const UNCHECKED = 'unchecked'
const CHECKED = 'checked'
const ERROR = 'error'

const CHECKED_UTILITY = '[[data-status=checked]_&]'
const ERROR_UTILITY = '[[data-status=error]_&]'

const STATUS_UTILITIES = {
  [CHECKED]: CHECKED_UTILITY,
  [ERROR]: ERROR_UTILITY,
}

const UTILITIES = Object.values(STATUS_UTILITIES)

export function useStatus() {
  const { selectedUtilities: utilities, setSelectedUtilities: setUtilities } = useUtilities()

  const status = useMemo(() => {
    if (utilities.includes(ERROR_UTILITY)) {
      return ERROR
    }
    if (utilities.includes(CHECKED_UTILITY)) {
      return CHECKED
    }
    return UNCHECKED
  }, [utilities])

  const setStatus = useCallback(newStatus => {
    const utility = STATUS_UTILITIES[newStatus]
    const filtered = utilities.filter(utility => !UTILITIES.includes(utility))
    setUtilities(utility ? [...filtered, utility] : filtered)
  }, [utilities, setUtilities])

  return { status, setStatus }
}

export function StatusActions() {
  const { selected } = useNode(({ events: { selected } }) => ({ selected }))
  const { status, setStatus } = useStatus()

  if (!selected) {
    return null
  }

  return <div className='flex items-center'>
    <Action onClick={() => setStatus(UNCHECKED)} className={`py-0.5! text-xs rounded-xs ${status === UNCHECKED ? 'bg-blue-400!' : ''}`}>
      Unchecked
    </Action>
    <Action onClick={() => setStatus(CHECKED)} className={`py-0.5! text-xs rounded-xs ${status === CHECKED ? 'bg-blue-400!' : ''}`}>
      Checked
    </Action>
    <Action onClick={() => setStatus(ERROR)} className={`py-0.5! text-xs rounded-xs ${status === ERROR ? 'bg-blue-400!' : ''}`}>
      Error
    </Action>
  </div>
}
